export interface VoiceChatBalance {
  monthlyLimitMinutes: number;
  usedSeconds: number;
  remainingSeconds: number;
}

interface RawVoiceChatBalance {
  monthly_limit_minutes?: number;
  used_seconds?: number;
  remaining_seconds?: number;
}

/** Default do contrato do pooler quando o payload não traz o limite. */
const DEFAULT_MONTHLY_LIMIT_MINUTES = 120;

/** Quota é por device (custo do SIM de cada câmera); ausência de consumo = saldo cheio. */
export const toVoiceChatBalance = (raw: RawVoiceChatBalance): VoiceChatBalance => {
  const monthlyLimitMinutes = raw.monthly_limit_minutes ?? DEFAULT_MONTHLY_LIMIT_MINUTES;
  return {
    monthlyLimitMinutes,
    usedSeconds: raw.used_seconds ?? 0,
    remainingSeconds: raw.remaining_seconds ?? monthlyLimitMinutes * 60,
  };
};
